import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import SetupMenu from "./SetupMenu";
import { scrollToTop } from "../Shared/ScrollOnTop";

function ManageStudentHouses() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);

  const loadList = () => {
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "StudentHouse/GetStudentHousesAdmin",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setRecords(response.data.ListofRecords || []);
        } else {
          setRecords([]);
          if (response.data.status_message) {
            toast.error(response.data.status_message);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });
  };

  useEffect(() => {
    document.title = "Manage Student Houses";
    setIsUpdated(false);
    loadList();
  }, [isUpdated]);

  const deleteHouse = (id) => {
    if (!window.confirm("Delete this student house?")) {
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "StudentHouse/DeleteStudentHouse",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ID: id },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message || "Delete failed.");
        }
      })
      .catch(() => toast.error("Network error."));
  };

  const renderRows = () => {
    if (records.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No student houses found
            </h4>
          </td>
        </tr>
      );
    }

    return records.map((item) => (
      <tr key={item.ID}>
        <td>{item.ID}</td>
        <td>{item.HouseName}</td>
        <td>{item.Is_Active ? "Yes" : "No"}</td>
        <td>
          <ul className="inline-action">
            <li>
              <NavLink
                to={`/Setup/EditStudentHouse/${item.ID}`}
                className="green"
                onClick={scrollToTop}
              >
                <i className="ri-edit-line"></i>
              </NavLink>
            </li>
            <li>
              <button
                type="button"
                className="red"
                onClick={() => deleteHouse(item.ID)}
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </li>
          </ul>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <SetupMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Setup/SetupDashboard">Setup</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Student Houses
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Student Houses</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Setup/AddStudentHouse"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Add Student House
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>House Name</th>
                    <th>Active</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageStudentHouses;
